// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__2qI6v","animate":"Popup_animate__2ldb2","fadeIn":"Popup_fadeIn__1uHpG"};